export const brands = [
  {
    id: 'supertec',
    name: 'SuperTec',
    logo: '/brands/supertec.svg',
    tier: 'master',
    invertOnDark: true,
    description:
      'SuperTec is a leading manufacturer of high-quality ceiling tiles, plasterboard and related building products. Known for innovation and reliability, their product range is trusted by professionals across Southern Africa.',
    brandProducts: ['Ceiling Tiles', 'Plasterboard', 'Jointing Compounds', 'Cornices'],
    website: null,
  },
  {
    id: 'etex',
    name: 'ETEX',
    logo: '/brands/etex.svg',
    tier: 'master',
    invertOnDark: true,
    description:
      'ETEX is a global leader in lightweight building solutions, producing fibre cement and plasterboard products used in construction worldwide. Their commitment to sustainable building drives innovation across their product range.',
    brandProducts: ['Fibre Cement Boards', 'Plasterboard', 'Fire-Resistant Boards'],
    website: 'https://www.etexgroup.com',
  },
  {
    id: 'siniat',
    name: 'Siniat',
    logo: '/brands/siniat.svg',
    tier: 'master',
    invertOnDark: true,
    description:
      'Siniat, part of the Etex Group, specialises in interior building solutions including plasterboard, compounds, and metal framing systems. Their products are designed for performance, durability and ease of installation.',
    brandProducts: ['Plasterboard', 'Compounds & Plasters', 'Metal Framing', 'Acoustic Solutions'],
    website: 'https://www.siniat.com',
  },
  {
    id: 'owa',
    name: 'Speciality Design Concepts (OWA)',
    shortName: 'OWA',
    logo: '/brands/owa.png',
    tier: 'master',
    invertOnDark: true,
    description:
      'OWA is a premium manufacturer of mineral fibre ceiling tiles and acoustic solutions. Their products deliver outstanding sound absorption, fire resistance and aesthetic appeal for commercial and residential spaces.',
    brandProducts: ['Mineral Fibre Ceiling Tiles', 'Acoustic Panels', 'Metal Ceiling Systems'],
    website: null,
  },
  {
    id: 'knauf',
    name: 'KNAUF',
    logo: '/brands/knauf.svg',
    tier: 'also',
    invertOnDark: true,
    description:
      "KNAUF is one of the world's largest manufacturers of building materials, producing plasterboard, insulation, and drylining systems. Trusted globally for consistent quality and comprehensive product support.",
    brandProducts: ['Plasterboard', 'Insulation', 'Drylining Systems', 'Plasters'],
    website: 'https://www.knauf.com',
  },
  {
    id: 'knauf-insulation',
    name: 'Knauf Insulation',
    logo: '/brands/knauf-insulation.svg',
    tier: 'also',
    invertOnDark: true,
    description:
      'Knauf Insulation is a South African manufacturer of insulation products. Their range includes glass wool insulation, mineral wool insulation, polyurethane insulation and polystyrene insulation.',
    brandProducts: ['Glass Wool Insulation', 'Mineral Wool Insulation', 'Polyurethane Insulation', 'Polystyrene Insulation'],
    website: 'https://www.knauf-insulation.co.za',
  },
  {
    id: 'capco',
    name: 'CAPCO',
    logo: '/brands/capco.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'CAPCO supplies a wide range of building products including ceiling components, fasteners, and drywall accessories. A reliable source for the essentials that keep projects moving.',
    brandProducts: ['Ceiling Components', 'Fasteners', 'Drywall Accessories'],
    website: null,
  },
  {
    id: 'casofour',
    name: 'Casofour',
    logo: '/brands/casofour.png',
    tier: 'also',
    invertOnDark: false,
    description:
      "Casofour is a proudly South African gypsum plaster manufacturer, founded in 2017. Born from a desire to give plasterers more choice after decades of market dominance by a single global supplier, their products are formulated to suit Southern Africa's diverse plastering conditions — from coastal humidity to inland climates. Today, Casofour is one of the fastest-growing gypsum plasters in Southern Africa.",
    brandProducts: ['Handskim Blue', 'Handskim Yellow', 'Jointfill'],
    website: 'https://casofour.co.za',
  },
  {
    id: 'isover',
    name: 'Isover',
    logo: '/brands/isover.png',
    tier: 'also',
    invertOnDark: true,
    description:
      'Isover, part of the Saint-Gobain group, is a world leader in insulation solutions. Their glass wool and multi-material insulation products deliver thermal and acoustic performance for energy-efficient buildings.',
    brandProducts: ['Glass Wool Insulation', 'Thermal Insulation', 'Acoustic Insulation'],
    website: 'https://www.isover.com',
  },
  {
    id: 'gyproc',
    name: 'Saint-Gobain Gyproc',
    logo: '/brands/gyproc.png',
    tier: 'also',
    invertOnDark: true,
    description:
      "Gyproc, part of the Saint-Gobain group, is South Africa's premier manufacturer of gypsum-based building solutions. Their product range includes RhinoBoard plasterboard, RhinoLite plasters, Gypframe steel ceiling grids and comprehensive drywall systems for walls, ceilings and partitions.",
    brandProducts: ['Plasterboard (RhinoBoard)', 'Plasters (RhinoLite)', 'Steel Ceiling Grids (Gypframe)', 'Drywall Systems'],
    website: 'https://www.gyproc.co.za',
  },
  {
    id: 'isotherm',
    name: 'Isotherm',
    logo: '/brands/isotherm.jpg',
    tier: 'also',
    invertOnDark: false,
    description:
      'Isotherm is a proudly South African thermal insulation product made from 100% recycled PET bottles. Non-toxic, non-allergenic and moisture resistant, it delivers excellent thermal and acoustic performance while being safe to handle without protective gear.',
    brandProducts: ['Roof & Ceiling Insulation', 'Wall Insulation', 'Underfloor Insulation', 'Geyser Blankets'],
    website: 'https://www.isotherm.co.za',
  },
  {
    id: 'rhinoroc',
    name: 'RhinoROC',
    logo: '/brands/rhinoroc.svg',
    tier: 'also',
    invertOnDark: true,
    description:
      'RhinoROC is Gyproc’s locally manufactured asbestos-free fibre cement range, designed for South African conditions. Suitable for internal ceilings, wet areas, external cladding, soffits and fascias — durable, moisture resistant and dimensionally stable.',
    brandProducts: ['Fibre Cement Flat Sheets', 'Fascia Boards', 'External Cladding', 'Wet Area Boards'],
    website: 'https://www.gyproc.co.za',
  },
  {
    id: 'nutec',
    name: 'Nutec',
    logo: '/brands/nutec.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'Nutec, manufactured by Everite Building Products since 1941, is a trusted South African brand of asbestos-free fibre cement products. Their range includes ceiling boards, cornices, roofing slates, cladding and insulation — known for moisture resistance, durability and affordability.',
    brandProducts: ['Fibre Cement Ceiling Boards', 'Cornices', 'Ceiling Insulation', 'Cladding & Flat Sheets'],
    website: 'https://www.everite.co.za',
  },
  {
    id: 'mecoladder',
    name: 'MecoLadder',
    logo: '/brands/mecoladder.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'MecoLadder is a South African aluminium ladder manufacturer founded in 1981, based in Cape Town. With over 40 years of experience, they supply industrial, agricultural and household markets with a comprehensive range of ladders and aluminium scaffolding towers.',
    brandProducts: ['A-Frame Step Ladders', 'Extension Ladders', 'Scaffolding Towers', 'Fruit Picking Ladders'],
    website: 'https://mecoladder.co.za',
  },
  {
    id: 'summit',
    name: 'Summit',
    logo: '/brands/summit.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'Summit, part of the Swartland Group, specialises in extruded polystyrene (XPS) insulation boards, ceiling access panels, polystyrene cornices and Knauf glass wool insulation. With national distribution and branches across South Africa, they deliver quality insulation solutions for residential, commercial and agricultural buildings.',
    brandProducts: ['XPS Insulation Boards', 'Ceiling Access Panels', 'Polystyrene Cornices', 'Knauf Glass Wool Insulation'],
    website: 'https://summitxps.co.za',
  },
  {
    id: 'aerolite',
    name: 'Aerolite',
    logo: '/brands/aerolite.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'Aerolite is a South African manufacturer of insulation products. Their range includes glass wool insulation, mineral wool insulation, polyurethane insulation and polystyrene insulation.',
    brandProducts: ['Glass Wool Insulation', 'Mineral Wool Insulation', 'Polyurethane Insulation', 'Polystyrene Insulation'],
    website: 'https://www.aerolite.co.za',
  },
  {
    id: 'ite',
    name: 'iTe',
    logo: '/brands/ite.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'iTe specialises in innovative gypsum-based patching and lightweight plaster solutions for interior finishing. Their product range is designed for fast, reliable repairs and level adjustments on drywall and plaster surfaces.',
    brandProducts: ['iTe Patch', 'iTe Duralite D50', 'iTe Duralite D100'],
    website: null,
  },
  {
    id: 'swartland',
    name: 'Swartland',
    logo: '/brands/swartland.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'Swartland is a leading South African manufacturer of aluminium building products. Their range of aluminium door frames and glazing sections are widely specified in drywall and commercial interior construction.',
    brandProducts: ['Aluminium Door Frames', 'Aluminium Glazing Sections'],
    website: 'https://www.swartland.co.za',
  },
  {
    id: 'youngmans',
    name: 'Youngman Roofing & Insulation',
    shortName: 'Youngman',
    logo: '/brands/youngmans.png',
    tier: 'also',
    invertOnDark: false,
    description:
      'WC Youngman S.A (Pty) Ltd, trading as Youngman Roofing, is a well-established company of over 35 years and a leading supplier of roof sheeting and insulation products across South Africa. Their insulation range includes Youngtherm and Acoustisorb ceiling blankets, Isover glass wool, Lambdaboard insulated ceiling boards, and radiant barriers — with a national footprint including a George branch serving the Southern Cape.',
    brandProducts: [
      'Youngtherm Insulation',
      'Acoustisorb Ceiling Blankets',
      'Lambdaboard Ceiling Boards',
      'Radiant Barriers',
    ],
    website: 'https://youngman.co.za',
  },
  {
    id: 'woodup',
    name: 'WoodUpp',
    logo: '/brands/woodup.svg',
    tier: 'also',
    invertOnDark: true,
    description:
      'WoodUpp designs and manufactures premium acoustic wood-slat cladding panels. Their Akupanel systems combine wood veneer or wood-like finishes with acoustic felt for Class A sound absorption in homes, offices and commercial interiors.',
    brandProducts: ['Akupanel Acoustic Panels', 'Acoustic Wall Cladding', 'Acoustic Ceiling Panels'],
    website: 'https://woodupp.co.za',
  },
];

export const getBrandById = (id) => brands.find((b) => b.id === id);
export const masterBrands = brands.filter((b) => b.tier === 'master');
export const additionalBrands = brands.filter((b) => b.tier === 'also');
export const brandLogoMap = Object.fromEntries(brands.map((b) => [b.id, b.logo]));
